import React from 'react';
import AppInputError from './input-error';

interface ITextAreaProps
  extends React.InputHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
  required?: boolean;
  value?: string;
  placeholder?: string;
  disabled?: boolean;
  onChange?: (event: React.ChangeEvent<HTMLTextAreaElement>) => void;
  rows?: number;
  id?: string;
  className?: string;
  errorMessage?: string;
  onInput?: (event: React.FormEvent<HTMLTextAreaElement>) => void;
}

const AppTextArea = React.forwardRef<HTMLTextAreaElement, ITextAreaProps>(
  (
    {
      label,
      required,
      rows,
      id,
      placeholder,
      disabled,
      className,
      onInput, // Include onInput
      errorMessage,
      value,
      onChange,
      ...rest
    }: ITextAreaProps,
    ref,
  ) => {
    return (
      <div className={className}>
        {label ? (
          <div className="mb-1 flex items-center gap-2">
            <p className="font-semibold text-xs">{label}</p>
            <p className={`text-red-500 ${required ? '' : 'invisible'}`}>*</p>
          </div>
        ) : null}

        <textarea
          id={id}
          rows={rows || 4}
          disabled={disabled}
          placeholder={placeholder}
          className="w-full text-sm focus:outline-none p-3 rounded-xl text-gray-700 bg-[#FAFAFA]"
          ref={ref}
          onInput={onInput}
          onChange={onChange}
          value={value}
          {...rest}
        ></textarea>
        {errorMessage && <AppInputError text={errorMessage} />}
      </div>
    );
  },
);

AppTextArea.displayName = 'Input';

export default AppTextArea;
